import React, { useContext, useEffect, useState } from "react";
import TextInput from "./TextInput";
import { Button, Col, Row } from "react-bootstrap";
import { CrackersContext } from "../CrackersContext";
import { raisePostRequest } from "../AxiosAPI";
import { LoadingBorder } from "./LoadingSpinner";
import { useNavigate } from "react-router-dom";
import { isValidMobileNumber } from "../CrackersUtil";

function CheckOut() {
    const [loading, setLoading] = useState(false);
    const [district, setDistrict] = useState("");
    const [thaluka, setThaluka] = useState("");
    const [city, setCity] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [pincode, setPincode] = useState("");
    const [amount, setAmount] = useState("");
    const [qty, setQty] = useState("");
    const {setShowErrorToastStatus, setToastBody } = useContext(CrackersContext);
    const captionDistrict = 'Enter District to deliver', captionThaluka = "Enter Thaluka to deliver", captionCity = "Enter City to Deliver", captionMobNo = "Mobile Number of Delivery", captionPincode = "Pincode of your city";

    const [districtValidation, setDistrictValidation] = useState({});
    const [thalukaValidation, setThalukaValidation] = useState({});
    const [cityValidation, setCityValidation] = useState({});
    const [pincodeValidation, setPincodeValidation] = useState({});
    const [mobileNumberValidation, setMobileNumberValidation] = useState({});

    const navigate = useNavigate();

    const styles = {
        // position: "absolute",
        // top: "50%",
        // left: "50%",
        // transform: "translate(-50%, -50%) translate3d(0,0,0)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }

    useEffect(() => {
        const cartValue = async () => {
            const response = await raisePostRequest(`/carts/check-out`, null, null, setShowErrorToastStatus, setToastBody);
            if(response && response.status === 'success') {
                setAmount(response.cart_value);
                setQty(response.quantity);
            }
        }
        cartValue();
    }, [])

    const validateDistrict = (district) => {
        const error = {};
        if(!district || district.trim() === '') {
            error.reason = "District is required";
            error.validation = false;
        }
        if(Object.keys(error).length > 0) {
            setDistrictValidation(error);
        } else {
            setDistrictValidation({"validation" : true})
        }
    }

    const validateThaluka = (thaluka) => {
        const error = {};
        if(!thaluka || thaluka.trim() === '') {
            error.reason = "Thaluka is required";
            error.validation = false;
        }
        if(Object.keys(error).length > 0) {
            setThalukaValidation(error);
        } else {
            setThalukaValidation({"validation" : true})
        }
    }

    const validateCity = (city) => {
        const error = {};
        if(!city || city.trim() === '') {
            error.reason = "City is required";
            error.validation = false;
        }
        if(Object.keys(error).length > 0) {
            setCityValidation(error);
        } else {
            setCityValidation({"validation" : true})
        }
    }

    const validatePincode = (pincode) => {
        const error = {};
        if(!pincode || pincode.trim() === '') {
            error.reason = "Pincode is required";
            error.validation = false;
        }
        if(Object.keys(error).length > 0) {
            setPincodeValidation(error);
        } else {
            setPincodeValidation({"validation" : true})
        }
    }

    const clear = () => {
        setDistrict('');
        setThaluka('');
        setCity('');
        setMobileNo('');
        setPincode('');
    }

    const placeOrder = async () => {
        validateDistrict(district);
        validateThaluka(thaluka);
        validateCity(city);
        validateMobileNumber()
        validatePincode(pincode);
        const validation = districtValidation.validation && thalukaValidation.validation && cityValidation.validation && pincodeValidation.validation;
        if(validation) {
            const response = await raisePostRequest("/carts/place-order/", {"district" : district, "thaluka" : thaluka, "city" : city, "location" : mobileNo ? mobileNo : null, "pincode" : pincode}, setLoading, setShowErrorToastStatus, setToastBody);
            if(response) {
                setDistrictValidation({});
                setThalukaValidation({});
                setCityValidation({});
                setPincodeValidation({})
                clear();
                const orderId = response["order_id"];
                navigate(`/web/orders/${orderId}`);
            }
            
        }
    }
    
    const validateMobileNumber = (value) => {
        const errors = {};
        if (!value) {
            errors.validation = false;
            errors.reason = "Mobile number is required";
        } else if (!isValidMobileNumber(value)) {
            errors.validation = false;
            errors.reason = "Invalid Mobile Number";
        }
        if(Object.keys(errors).length > 0) {
            setMobileNumberValidation(errors);
            return false;
        } else {
            setMobileNumberValidation({"validation" : true});
            return true;
        }
    };

    return (
        <>
            <div style={styles}>
                <Row>
                    <div>
                        <h5>Your cart(s) total price is <b>₹ {amount - 200},</b> and the total quantity of items is <b>{qty}</b>.</h5>
                    </div>
                    <div className="check-out-ip">
                        <TextInput caption={captionDistrict}
                            value={district}
                            onChange={setDistrict}
                            validation={districtValidation}
                            info={""}
                            onFocusCaption={"District"}
                            validator={validateDistrict}
                            isMultiLine={false} />
                        <TextInput caption={captionThaluka}
                            value={thaluka}
                            onChange={setThaluka}
                            validation={thalukaValidation}
                            info={""}
                            onFocusCaption={"Thaluka"}
                            validator={validateThaluka}
                            isMultiLine={false} />
                        <TextInput caption={captionCity}
                            value={city}
                            onChange={setCity}
                            validation={cityValidation}
                            info={""}
                            onFocusCaption={"City"}
                            validator={validateCity}
                            isMultiLine={false} />
                        <TextInput caption={captionMobNo}
                            value={mobileNo}
                            onChange={setMobileNo}
                            validation={mobileNumberValidation}
                            info={""}
                            onFocusCaption={"Mobile Number"}
                            validator={validateMobileNumber}
                            isMultiLine={false}
                            isNumericField={true} />
                        <TextInput caption={captionPincode}
                            value={pincode}
                            onChange={setPincode}
                            validation={pincodeValidation}
                            info={""}
                            onFocusCaption={"Pincode"}
                            validator={validatePincode}
                            isMultiLine={false}
                            isNumericField={true} />
                    </div>
                </Row>
                <Row>
                    <Button variant="warning" onClick={placeOrder}>
                    {!loading && "Place Order"}
                    {loading && <LoadingBorder/>}
                    </Button>
                </Row>
            </div>
        </>
    );
}

export default CheckOut;